import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_CON023_Request,
  IAPI_CON023_Response,
} from "../../../type/apiType";
import {
  IAPI_CON014_Request,
  IAPI_CON014_Response,
} from "../../../type/apiType";

// 契約解除（中小企業退職金共済契約締結）内容入力表示
const httpIAPI_CON023 = async (
  param: IAPI_CON023_Request
): Promise<IAPI_CON023_Response> => {
  let res = await http.post(ApiUrl.API_CON023, {
    ...param,
  });
  return res.data;
};

//中小企業退職金共済契約締結届更新
const httpIAPI_CON014 = async (
  param: IAPI_CON014_Request
): Promise<IAPI_CON014_Response> => {
  let res = await http.post(ApiUrl.API_CON014, {
    ...param,
  });

  return res.data;
};

export { httpIAPI_CON023, httpIAPI_CON014 };
